import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import { ethers } from "ethers";
import { getNetworkProvider } from "helper/network";
import { useState } from "react";
import { toast } from "react-toastify";
import React from "react";

import { abi as StakeFeeAbi } from "../../contracts/StakeFee.sol/StakeFee.json";
import { abi as StakeAbi } from "../../contracts/StakeV2.1.sol/StakeV2.json";

const FeeType = {
  stake: 0,
  withdraw: 1,
  claim: 2,
  addBooster: 3,
  removeBooster: 4
}

export default function StakingFeeTest() {
  const [poolAddress, setPoolAddress] = useState("");
  const [userAddress, setUserAddress] = useState("");
  const [type, setType] = useState(0);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState("");

  async function testFee() {
    setLoading(true);
    try {
      const provider = getNetworkProvider();
      const stakeContract = new ethers.Contract(poolAddress, StakeAbi, provider);
      const stakingFeeAddress = await stakeContract.stakeFee().catch(() => {
        toast.error("Pool not support fee config");
      });

      if (!stakingFeeAddress) return;

      const contract = new ethers.Contract(stakingFeeAddress, StakeFeeAbi, provider)
      const fee = await contract.getFees(poolAddress, userAddress, type);
      setResult(fee.toString());
    } catch (e) {
      toast.error("Get fee failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <div style={{ marginBottom: '10px' }}>
        <TextField
          value={poolAddress}
          onChange={(event) => setPoolAddress(event.target.value)}
          variant="outlined"
          size="small"
          placeholder="Pool address"
        />
      </div>

      <div style={{ marginBottom: '10px' }}>
        <TextField
          value={userAddress}
          onChange={(event) => setUserAddress(event.target.value)}
          variant="outlined"
          size="small"
          placeholder="User address"
        />
      </div>

      <div style={{ marginBottom: '10px' }}>
        <FormControl style={{ width: '200px' }}>
          <InputLabel id="type-label">Type</InputLabel>
          <Select
            labelId="type-label"
            id="type"
            value={type}
            label="Type"
            onChange={(e) => setType(e.target.value)}
          >
            {
              Object.keys(FeeType).map((key) => (
                <MenuItem key={key} value={FeeType[key]}>{key}</MenuItem>
              ))
            }
          </Select>
        </FormControl>
      </div>

      <div style={{ marginBottom: '10px' }}>
        <Button variant="contained" color="primary" onClick={testFee} disabled={loading}>Test</Button>
      </div>

      <p>Result: {result}</p>
    </div>
  )
}
